import { types } from "./types";

export const setDerivedCustomerGroup = customerGroup => ({
  type: types.SET_DERIVED_CUSTOMER_GROUP,
  payload: customerGroup
});
